__turbopack_context__.v({
  "dialogBody": "SaveButton-module__svQ4kG__dialogBody",
  "dialogFooter": "SaveButton-module__svQ4kG__dialogFooter",
  "noUnderline": "SaveButton-module__svQ4kG__noUnderline",
  "saveButton": "SaveButton-module__svQ4kG__saveButton",
});
